export const sections = {
  about: true,
  testimonials: false,
  pricing: false,
  contact: true,
};

/*
Use this to control the display of different sections. Set a section to "false" to hide.

--about
  The about section allows you to provide a description of your app and its features.
--testimonials
  The testimonials section shows customer reviews and brands you have worked with.
--pricing
  The pricing section shows the pricing plans of your app.
--contact
  This shows a contact form that uses can use to provide feedback.
*/
